module.exports = "<div class=\"link-panel panel\" [class.hide]=\"!isShown\">\r\n    <div class=\"panel-heading\">\r\n        <button class=\"close\" (click)=\"hide()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button>\r\n    </div>\r\n    <div class=\"panel-body\">\r\n\r\n          <div class=\"form-group row\">\r\n              <div class=\"col-xs-12\">\r\n              <textarea class=\"form-control\" id=\"exampleTextarea\" rows=\"5\">{{link}}</textarea>\r\n                  </div>\r\n          </div>\r\n\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/popups/link_box.component.html
// module id = 556
// module chunks = 1